module.exports = __webpack_public_path__ + "img/speech.6574c096.svg";